import { useIsTabletS } from '@/hooks/use-media-query'

import { config } from './config'
import {
  SubTitle,
  Title,
  Cards,
  Wrapper,
  Card,
  TableTitle,
  TableSubtitle,
  SectionWrapper,
  SectionItem,
  TextSections,
  HexagonLeft,
  HexagonRight,
} from './styles'

const {
  title,
  text,
  cards,
  textBottom,
  sections,
  hexagons: {
    hexagonLeft,
    hexagonRight,
    hexagonLeftMobile,
    hexagonRightMobile,
  },
} = config

export function Result() {
  const isTablet = useIsTabletS()

  const tabletImageLeft = !isTablet ? hexagonLeftMobile : hexagonLeft
  const tabletImageRight = !isTablet ? hexagonRightMobile : hexagonRight

  return (
    <Wrapper>
      <Title as="h2">{title}</Title>
      <SubTitle>{text}</SubTitle>
      <SectionWrapper>
        <HexagonLeft {...tabletImageLeft} />
        <HexagonRight {...tabletImageRight} />
        {sections.map(({ backgroundColor, text, id }) => (
          <SectionItem key={id} color={backgroundColor}>
            <TextSections> {text}</TextSections>
          </SectionItem>
        ))}
      </SectionWrapper>

      <SubTitle>{textBottom}</SubTitle>
      <Cards>
        {cards.map(({ title, subtitle, id }) => (
          <Card key={id}>
            <TableTitle as="h3">{title}</TableTitle>
            <TableSubtitle>{subtitle}</TableSubtitle>
          </Card>
        ))}
      </Cards>
    </Wrapper>
  )
}
